import { Redirect, Stack } from 'expo-router';
import React from 'react';
import { View } from 'react-native';

import { useAuthStore } from '@/store/authStore';
import { CLIENT_HOME_PATH, isProviderUser } from '@/utils/user-role';

export default function ProviderLayout() {
  const user = useAuthStore((state) => state.user);

  // Grupos não entram na URL: `/reports`, `/profile` e afins existem nos dois
  // lados. Sem esta guarda, um cliente que caia numa rota de prestador
  // renderiza a tela do prestador inteira.
  if (user && !isProviderUser(user)) {
    return <Redirect href={CLIENT_HOME_PATH} />;
  }

  return (
    <View style={{ flex: 1 }}>
      <Stack
        screenOptions={{
          headerShown: false,
        }}
      >
        <Stack.Screen name="index" />
        <Stack.Screen name="home" />
        <Stack.Screen name="services" />
        <Stack.Screen name="schedule" />
        <Stack.Screen name="enrollments" />
        <Stack.Screen name="clients" />
        <Stack.Screen name="charges" />
        <Stack.Screen name="transactions" />
        <Stack.Screen name="disputes" />
        <Stack.Screen name="reports" />
        <Stack.Screen name="expenses" />
        <Stack.Screen name="retroactive" />
        <Stack.Screen name="assistant" />
        <Stack.Screen name="payments" />
      </Stack>
    </View>
  );
}
